import React, { useContext, useEffect, useState } from "react";
import Footer from "./footer";
import HomeCounters from "./Homecounters";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";



function Annualcompliancellp() {
   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
         const parsedUser = JSON.parse(storedUser);
         setNewData((prevData) => ({
            ...prevData,
            user_name: parsedUser.name || "",
            user_email: parsedUser.email || "",
            user_contact_number: parsedUser.mobile || "",
            user_city: parsedUser.city || "",
         }));
      }
   }, []);

   const [activeQuestion, setActiveQuestion] = useState(null);
   const { http, token } = AuthUser();
   const navigate = useNavigate();
   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };

   const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact_number: '', user_city: '' })

   const [errors, setErrors] = useState({});

   const { services, loading, error } = useContext(ServicesContext);
   if (loading) {
      return <div>Loading...</div>;  // Show loading state while fetching data
   }

   if (error) {
      return <div>{error}</div> // Show error state if there was an issue fetching data
   }
   const service = services.find(s => s.service_id === 7);

   const validateForm = () => {
      const newErrors = {};

      if (!newData.user_name.trim()) {
         newErrors.user_name = 'Name is required.';
      } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
      }


      if (!newData.user_email.trim()) {
         newErrors.user_email = 'Email is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
         newErrors.user_email = 'Enter a valid email address.';
      }

      if (newData.user_contact_number && !/^\d{10}$/.test(newData.user_contact_number)) {
         newErrors.user_contact_number = 'Enter a valid 10-digit contact number.';
      }

      if (!newData.user_city) {
         newErrors.user_city = 'City/District is required.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // No errors
   };




   // const formPutPartenshipdeed = async (e) => {
   //    e.preventDefault();

   //    // ✅ Check if user is logged in
   //    // if (!token) {
   //    //     alert("Please log in to continue.");
   //    //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
   //    //    navigate('/login'); // 👈 Use this if you're using React Router
   //    //    return;
   //    // }
   //    if (!validateForm()) return;

   //    localStorage.setItem("bookingData", JSON.stringify(newData));

   //    // Navigate to checkout
   //    navigate('/checkout', {
   //       state: {
   //          service: service,

   //       }
   //    });

   // };

      const formPutPartenshipdeed = async (e) => {
       e.preventDefault();
   
       if (!validateForm()) return;
   
       try {
           const response = await PartenerSheepDeedService.annualComplainForm(newData);
   
           console.log("API Success:", response);
   
           navigate("/thankyou");
   
           // Optional: reset form
           setNewData(prev => {
  const resetObj = {};
  Object.keys(prev).forEach(key => (resetObj[key] = ""));
  return resetObj;
});
    
   
       } catch (error) {
           console.error("API Error:", error);
           alert("Something went wrong!");
       }
   };


   return (
      <div>


         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <p className="pdrl-text"><img src="assets/img/image/Line.png" className="line-image" /> <span className="text-color">250k+</span> <span>People trust us</span></p>
                        <h1 className="sk-text-color">Annual Compliance (LLP)</h1>

                        <p className="pdrl-text">Get Annual Compliance for Limited Liability Partnership (LLP) for only <span className="text-color">Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                        <p className="pd-text">Government fees and stamp duties are extra. Please fill out the form to receive a detailed quote in seconds. </p>
                        <p className="pd-text text-center star-text">Within 2 Weeks <span><img className="star" src="assets/image/star.svg" alt="" /></span> Transparent Pricing <span><img className="star" src="assets/image/star.svg" alt="" /></span> No Hidden Fees.</p>
                        <div className="couter-all">
                           <div className="row package-section">
                              <p className="ps-text">Get Absolutely Free In Package</p>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/pan-tax-registration.svg" />
                                    <p>Complete Documentation</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/din-and-dsc-for-directors.svg" />
                                    <p>Tax Planning</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/personal-assistance.svg" />
                                    <p>Personal Assistance</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/complete-document.svg" />
                                    <p>Planning and Consultation</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box dis">
                                    <img src="assets/img/image/personal-assistance.svg" />
                                    <p>Dedicated Support</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3>Annual Compliance (LLP)
                           </h3>          <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Final Price, No Hidden Costs)</span></p>
                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Contact Number<span className="red">*</span></label>{errors.user_contact_number && <p className="error-text">{errors.user_contact_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact_number} onChange={(e) => setNewData({ ...newData, user_contact_number: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                       <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_city"
                                          errors={errors}
                                       />
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3 btn-color" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space60 bg-white"></div>

         <div className="home4-counters bg-white">
            <div className="container">

               <div className="row">
                  <div className="col-md-12">


                     <HomeCounters />
                  </div>
               </div>


               <div className="space40"></div>
               <div className="row">

                  <div className="col-lg-4">
                     <img src="assets/img/images/Annual-Compliance-LLP.png" alt="" />
                  </div>
                  <div className="col-lg-8">

                     <h2>Annual Compliance LLP </h2>


                     <p className="pd-text">Stay compliant and stress-free with Dm2Legal’s Annual Compliance for LLP service! We take care of all your LLP’s legal and regulatory obligations, ensuring seamless compliance in India.

                        Our comprehensive package covers:<br />

                        ✅ Filing the Annual Return with the Ministry of Corporate Affairs (MCA) <br />
                        ✅ Timely submission of Financial Statements <br />
                        ✅ Appointing an auditor for financial audits <br />
                        ✅ Conducting the Annual General Meeting (AGM) <br />
                        ✅ Maintaining accurate books of accounts <br />
                        ✅ Managing tax compliance, including Income Tax & GST returns <br />

                        With our expert team handling all documentation and filings, you can avoid penalties and focus on growing your business. <br />
                        Don’t risk non-compliance—trust Dm2Legal for hassle-free LLP compliance!<br />

                        📞 Contact us today!</p>
                  </div>

               </div>


            </div>
         </div>



         <div className="service-binifits9 bg-white" >
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">How to apply</h2>
                        <div className="space20"></div>
                        <img src="assets/img/changedimg/Annual-Compliance-LLP.png" />
                     </div>
                     <div className="space20"></div>
                  </div>
               </div>
            </div>
         </div>
         <div className="space20 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate text-center">Benefits </h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon1.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Legal Compliance</a></h4>
                           <p className="font-f-7">Annual compliance ensures that your LLP meets all legal and regulatory requirements, helping you avoid penalties and legal consequences.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon2.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Good Corporate Governance</a></h4>
                           <p className="font-f-7">Compliance promotes strong corporate governance practices, improving transparency and accountability within your LLP.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon3.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Business Continuity</a></h4>
                           <p className="font-f-7">Consistent compliance ensures the smooth operation of your LLP, minimizing the risk of disruptions and supporting long-term business continuity.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon5.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Investor Confidence</a></h4>
                           <p className="font-f-7">Maintaining compliance reflects your LLP's dedication to transparency and ethical business practices, helping to attract investors and build trust in your company.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon6.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Enhanced Credibility</a></h4>
                           <p className="font-f-7">Compliance highlights your LLP as a dependable and trustworthy business, strengthening its reputation and credibility in the market.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/work6-icon3.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Access to Funding</a></h4>
                           <p className="font-f-7">Compliant LLPs are more likely to secure funding from banks, financial institutions, and venture capitalists due to their demonstrated adherence to legal and regulatory standards.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon4.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Statutory Benefits</a></h4>
                           <p className="font-f-7">Compliance allows your LLP to access government-provided statutory benefits, incentives, and concessions, ensuring it can take advantage of available opportunities.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/brand6-4.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Risk Mitigation</a></h4>
                           <p className="font-f-7">Consistent compliance helps identify and address potential risks, protecting your LLP's interests and minimizing liabilities.</p>
                        </div>
                     </div>
                  </div>
                  {/* <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon6.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Smooth Audit Process</a></h4>
                           <p className="font-f-7">Compliance streamlines the audit process by ensuring well-organized records and financial statements, making audits more efficient.</p>
                        </div>
                     </div>
                  </div> */}
                  {/* <div className="col-lg-4">
                     <div className="service6-box s-box">
                        <div className="box-img">
                           <div className="service-box-icon box-icon">
                              <img src="assets/img/icons/service6-icon6.png" alt="" />
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><a href="single-service-1.html" className="font-f-7">Peace of Mind</a></h4>
                           <p className="font-f-7">Annual compliance offers peace of mind, assuring you that your LLP is operating within the legal framework and meeting all its obligations.</p>
                        </div>
                     </div>
                  </div> */}
               </div>
               <div className="space20"></div>
            </div>
         </div>

         <div className="service-binifits9 sp0" id="service2">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12 text-center">
                     <div className="hadding7">
                        <div className="space80"></div>
                        <h2>Online Registration Procedure </h2>
                     </div>
                     <div className="partnership-deade-section">
                        <div className="space40"></div>

                        <ul className="disc-list">
                           <li>
                              <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our team will thoroughly review the documents you've submitted, checking for any incorrect or inaccurate information to ensure your peace of mind.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our top GST experts are available to handle all document requirements and meet your registration needs.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>File your Annual Returns and Financial Statements within the specified timeline with the Ministry of Corporate Affairs (MCA).</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Engage an auditor to audit the LLP’s financial statements, conduct the AGM to approve the statements, and fulfill tax compliance obligations.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                              <span>Filing Annual Returns, appointing an auditor, and conducting an Annual General Meeting (AGM) are essential steps to ensure annual compliance for LLPs.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                        </ul>

                        <div className="space80"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>



         <div className="bg-white">

            <div className="container">
               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                              <div className="space30"></div>
                              <div id="general">


                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                       Q1: When is the due date for filing an LLP’s Annual Return in India?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          An LLP must file its Annual Return (Form 11) by May 30 and Statement of Accounts (Form 8) by October 30 each year.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2: Does an LLP need to appoint an auditor?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          An LLP must appoint an auditor only if its turnover exceeds ₹40 lakh or capital contribution exceeds ₹25 lakh.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3: What are the consequences of non-compliance with LLP annual requirements?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Failure to comply can lead to penalties, late fees, and even LLP strike-off by the MCA, with fines starting at ₹100 per day.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4: Is an LLP required to conduct an Annual General Meeting (AGM)?
                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">No, an LLP is not required to hold an AGM, but it must file annual returns and financial statements with the MCA.</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5: Can an LLP hire a service provider for compliance management?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Yes, an LLP can outsource its compliance obligations to a professional service provider for filings, audits, and legal requirements.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6: Must an LLP maintain proper books of accounts?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Yes, an LLP must maintain books of accounts, either on a cash or accrual basis, and keep records at its registered office.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                       Q7: What are the tax compliance requirements for an LLP?
                                       <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          An LLP must file income tax returns (ITR-5), GST returns (if applicable), and tax audit reports if turnover exceeds ₹1 crore.                                       </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8: Is it possible to complete LLP annual compliance online?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Yes, LLP annual compliance can be done online through the MCA portal, including filing Form 11, Form 8, and tax returns.                                       </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(9)}
                                    >
                                       Q9: What happens if an LLP does not appoint an auditor?
                                       <span>
                                          {activeQuestion === 9 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          If an LLP crosses the audit threshold but fails to appoint an auditor, it may face penalties, fines, and compliance issues with the MCA and Income Tax Department.                                       </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(10)}
                                    >
                                       Q10: How frequently should an LLP check its compliance status?
                                       <span>
                                          {activeQuestion === 10 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          An LLP should review its compliance status annually and before key filings to avoid penalties and ensure regulatory compliance.                                       </p>
                                    </div>
                                 </div>

                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-7 m-auto text-center">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate">Why Choose Us?</h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                           <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                           <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                           <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                           <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                           <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         < WhatsAppScrollButton />

         <Footer />
         <CircularScrollProgress />
      </div>

   );
}
export default Annualcompliancellp;